import React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import fetchUrl from '../../utils/fetch.ts';
import { GlobalContext } from '../../state'
import { useStream } from '../../context/StreamContext';

function LogoutButton() {
  const navigate = useNavigate();
  const { setGlobalState } = React.useContext(GlobalContext);
  const wsManager = useStream();

  const handleLogout = async () => {
    // Close WebSocket before clearing auth to stop real-time data streaming
    if (wsManager) {
      wsManager.disconnect();
    }

    try {
      await fetchUrl(`/v1/logout`);
    } catch (e) {
      // Server-side logout is best-effort; client cleanup continues regardless
    }

    setGlobalState((prev) => ({
      ...prev,
      user: null,
      isAuthenticated: false,
      token: null,
      rights: [],
      activeMenuItem: null,
    }));

    // Clear all auth-related localStorage to prevent data leakage after logout
    localStorage.removeItem('token');
    localStorage.removeItem('rights');
    localStorage.removeItem('apikey');

    navigate('/');
  };

  return (
    <Button
      variant="contained"
      color="error"
      style={{ position: 'absolute', top: 20, right: 20 }}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
}

export default LogoutButton;